var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission)?_c('Card',{staticClass:"pastServices",attrs:{"title":_vm.$t('pastServices.title'),"flexContent":"","condensed":""}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }